exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Styles used in custom filter component. */\n\n.ag-menu{\n    overflow: unset !important\n}", ""]);

// exports
